/*
 *   File : orders.js
 *   Author URI : https://evoqueinnovativelab.com
 *   Description : Order list;
 *   Integrations :30-05-2023
 *   Version : v1.0
 *   Created :30-05-2023
*/
/*import packages*/
import { useState, useEffect } from 'react';

/*import components*/
import { DataTable, FundsTab } from '../../components/dataFormating/index';
import { Loader } from '../../components/loader';
import { Toast } from '../../components/note';
import { EmptyNote } from '../../components/note';

/* import services */
import devconfig from '../../config/config';
import APIPost from '../../services/postApi';



const StpList = (props) => {

    const [index, setIndex] = useState(1);
    const [loader, setLoader] = useState(false);
    const [error, setError] = useState(null);
    const [stpData, setStpData] = useState([]);
    /* Total amount for the current tab, across all rows. Provided by the
     * backend as `total_amount` alongside `data` — not summed client-side.
     * Shared across tabs, refreshed by whichever tab's list call last ran. */
    const [totalAmount, setTotalAmount] = useState(null);
    const [success, setSuccess] = useState(null);


    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });


    }, []);

    useEffect(() => {
        switch (index) {
            case 1:
                _getActiveStps();
                break;
            case 2:
                _getCancelledStps();
                break;
            case 3:
                _getPausedStps();
                break;


            default:
                break;
        }
        //eslint-disable-next-line
    }, [index]);


    useEffect(() => {
        setTimeout(() => {
            if (error !== null) {
                setError(null);
            }
        }, 3000);
    }, [error]);

    useEffect(() => {
        if (success !== null) {
            setTimeout(() => {
                setSuccess(null)
            }, 3000)
        }
    }, [success])



    /*--------- active sip -----------*/
    const _getActiveStps = (query) => {
        setLoader(true)
        let url = devconfig.admin + '/user/active-stp-list';

        let data = JSON.stringify({
            customer_id: Number(props.id),
            "goal_id": [],

        });
        APIPost(url, data).then((response) => {
            if (response.status_code === 200) {
                setStpData(response.data.data ?? response.data);
                setTotalAmount(response.data.total_amount ?? null);
                setLoader(false);
            } else {
                setStpData([]);
                setLoader(false);
            }
        });
    }


    /*--------- cancelled stps -----------*/
    const _getCancelledStps = (query) => {
        setLoader(true)
        let url = devconfig.admin + '/user/cancelled-stp-list';

        let data = JSON.stringify({
            customer_id: Number(props.id),
            "goal_id": [],
        });
        APIPost(url, data).then((response) => {
            if (response.status_code === 200) {
                setStpData(response.data.data ?? response.data);
                setTotalAmount(response.data.total_amount ?? null);
                setLoader(false);
            } else {
                setStpData([]);
                setLoader(false);
            }
        });
    }

    /*--------- paused stps -----------*/
    const _getPausedStps = (query) => {
        setLoader(true)
        let url = devconfig.admin + '/user/paused-stp-list';

        let data = JSON.stringify({
            customer_id: Number(props.id),
            "goal_id": [],
        });
        APIPost(url, data).then((response) => {
            if (response.status_code === 200) {
                setStpData(response.data.data ?? response.data);
                setTotalAmount(response.data.total_amount ?? null);
                setLoader(false);
            } else {
                setStpData([]);
                setLoader(false);
            }
        });
    }



    /*---- active sip table columns -----*/
    const ACTIVE_STP_COLUMNS = [
        {
            name: 'Basket/Fund',
            cell: (row) => <>
                {
                    row.image ?
                        <img src={row.image} alt="" draggable={false}
                            width="24px"
                            className='e-sip-image' />
                        :
                        null
                }
                <span className='ps-2'>{row.goal_name}</span>
            </>,
            sortable: false,
            left: true,
            width: "280px",
            defaultSortAsc: false,
        },
        {
            name: 'Frequency',
            selector: 'frequency',
            sortable: false,
            left: true,
            width: '150px',
            cell: (row) => <div className="col-lg-12" >
                {row.frequency}
            </div>
        },
        {
            name: 'Stp date',
            selector: 'date',
            sortable: false,
            left: true,
            width: '120px',
            cell: (row) => <div className="col-lg-12" >
                {row.date ? row.date : "--"}
            </div>
        },
        {
            name: 'Days',
            selector: 'days',
            sortable: false,
            left: true,
            width: '120px',
            cell: (row) => <div className="col-lg-12" >
                {row.days ? row.days : "--"}
            </div>
        },
        {
            name: 'Next date',
            selector: row => row.next_stp_date,
            sortable: false,
            left: true,
            width: '180px',
            // sortFunction: (a, b) => customDateSort(a, b, 'order_date',),
            cell: row => <div className="col-lg-12" >
                {row.next_stp_date ? row.next_stp_date : "--"}
            </div>
        },
        {
            name: 'Repeat day',
            selector: row => row.repeat_day,
            sortable: false,
            left: true,
            width: '180px',
            // sortFunction: (a, b) => customDateSort(a, b, 'order_date',),
            cell: row => <div className="col-lg-12" >
                {row.repeat_day ? row.repeat_day : "--"}
            </div>
        },
        {
            name: 'Amount (₹)',
            selector: row => row.stp_amount ? parseFloat(row.stp_amount) : 0,
            // selector: (row) => row.amount ? "₹" + parseFloat(row.amount.split("₹")[1]).toFixed(2) : '--',
            sortable: false,
            right: true,
            cell: row => <div onClick={() => { }}>
                {
                    row.stp_amount ?
                        row.stp_amount.toLocaleString('en-IN')
                        :
                        0
                }
            </div>

        },
        {
            name: 'Total Investment (₹)',
            width: '180px',
            selector: row => row.total_investment ? parseFloat(row.total_investment) : 0,
            // selector: (row) => row.amount ? "₹" + parseFloat(row.amount.split("₹")[1]).toFixed(2) : '--',
            sortable: false,
            right: true,
            cell: row => <div onClick={() => { }}>
                {
                    row.total_investment ?
                        row.total_investment.toLocaleString('en-IN')
                        :
                        0
                }
            </div>
        },
    ]

    /*---- cancelled sip table columns -----*/
    const CANCELLED_STP_COLUMNS = [
        {
            name: 'Basket/Fund',
            cell: (row) => <>
                {
                    row.image ?
                        <img src={row.image} alt="" draggable={false}
                            width="24px"
                            className='e-sip-image' />
                        :
                        null
                }
                <span className='ps-2'>{row.goal_name}</span>
            </>,
            sortable: false,
            left: true,
            width: "280px",
            defaultSortAsc: false,
        },
        {
            name: 'Frequency',
            selector: 'frequency',
            sortable: false,
            left: true,
            width: '150px',
            cell: (row) => <div className="col-lg-12" >
                {row.frequency}
            </div>
        },
        {
            name: 'Stp date',
            selector: 'date',
            sortable: false,
            left: true,
            width: '120px',
            cell: (row) => <div className="col-lg-12" >
                {row.date ? row.date : "--"}
            </div>
        },
        {
            name: 'Days',
            selector: 'days',
            sortable: false,
            left: true,
            width: '120px',
            cell: (row) => <div className="col-lg-12" >
                {row.days ? row.days : "--"}
            </div>
        },
        {
            name: 'Next date',
            selector: row => row.next_stp_date,
            sortable: false,
            left: true,
            width: '180px',
            // sortFunction: (a, b) => customDateSort(a, b, 'order_date',),
            cell: row => <div className="col-lg-12" >
                {row.next_stp_date ? row.next_stp_date : "--"}
            </div>
        },
        {
            name: 'Repeat day',
            selector: row => row.repeat_day,
            sortable: false,
            left: true,
            width: '180px',
            // sortFunction: (a, b) => customDateSort(a, b, 'order_date',),
            cell: row => <div className="col-lg-12" >
                {row.repeat_day ? row.repeat_day : "--"}
            </div>
        },
        {
            name: 'Amount (₹)',
            selector: row => row.stp_amount ? parseFloat(row.stp_amount) : 0,
            // selector: (row) => row.amount ? "₹" + parseFloat(row.amount.split("₹")[1]).toFixed(2) : '--',
            sortable: false,
            right: true,
            cell: row => <div onClick={() => { }}>
                {
                    row.stp_amount ?
                        row.stp_amount.toLocaleString('en-IN')
                        :
                        0
                }
            </div>

        },
        {
            name: 'Total Investment (₹)',
             width: '180px',
            selector: row => row.total_investment ? parseFloat(row.total_investment) : 0,
            // selector: (row) => row.amount ? "₹" + parseFloat(row.amount.split("₹")[1]).toFixed(2) : '--',
            sortable: false,
            right: true,
            cell: row => <div onClick={() => { }}>
                {
                    row.total_investment ?
                        row.total_investment.toLocaleString('en-IN')
                        :
                        0
                }
            </div>
        },
        {
            name: 'Cancelled reason',
            selector: row => row.cancelled_reason,
            sortable: false,
            left: true,
            width: '180px',
            // sortFunction: (a, b) => customDateSort(a, b, 'order_date',),
            cell: row => <div className="col-lg-12" >
                {row.cancelled_reason ? row.cancelled_reason : "--"}
            </div>
        },
    ]

    /*---- paused and failed sip table columns -----*/
    const COMMON_STP_COLUMNS = [
        {
            name: 'Basket/Fund',
            cell: (row) => <>
                {
                    row.image ?
                        <img src={row.image} alt="" draggable={false}
                            width="24px"
                            className='e-sip-image' />
                        :
                        null
                }
                <span className='ps-2'>{row.goal_name}</span>
            </>,
            sortable: false,
            left: true,
            width: "280px",
            defaultSortAsc: false,
        },
        {
            name: 'Frequency',
            selector: 'frequency',
            sortable: false,
            left: true,
            width: '150px',
            cell: (row) => <div className="col-lg-12" >
                {row.frequency}
            </div>
        },
        {
            name: 'Stp date',
            selector: 'date',
            sortable: false,
            left: true,
            width: '120px',
            cell: (row) => <div className="col-lg-12" >
                {row.date ? row.date : "--"}
            </div>
        },
        {
            name: 'Days',
            selector: 'days',
            sortable: false,
            left: true,
            width: '120px',
            cell: (row) => <div className="col-lg-12" >
                {row.days ? row.days : "--"}
            </div>
        },
        {
            name: 'Next date',
            selector: row => row.next_stp_date,
            sortable: false,
            left: true,
            width: '180px',
            // sortFunction: (a, b) => customDateSort(a, b, 'order_date',),
            cell: row => <div className="col-lg-12" >
                {row.next_stp_date ? row.next_stp_date : "--"}
            </div>
        },
        {
            name: 'Repeat day',
            selector: row => row.repeat_day,
            sortable: false,
            left: true,
            width: '180px',
            // sortFunction: (a, b) => customDateSort(a, b, 'order_date',),
            cell: row => <div className="col-lg-12" >
                {row.repeat_day ? row.repeat_day : "--"}
            </div>
        },
        {
            name: 'Amount (₹)',
            selector: row => row.stp_amount ? parseFloat(row.stp_amount) : 0,
            // selector: (row) => row.amount ? "₹" + parseFloat(row.amount.split("₹")[1]).toFixed(2) : '--',
            sortable: false,
            right: true,
            cell: row => <div onClick={() => { }}>
                {
                    row.stp_amount ?
                        row.stp_amount.toLocaleString('en-IN')
                        :
                        0
                }
            </div>

        },
        {
            name: 'Total Investment (₹)',
             width: '180px',
            selector: row => row.total_investment ? parseFloat(row.total_investment) : 0,
            // selector: (row) => row.amount ? "₹" + parseFloat(row.amount.split("₹")[1]).toFixed(2) : '--',
            sortable: false,
            right: true,
            cell: row => <div onClick={() => { }}>
                {
                    row.total_investment ?
                        row.total_investment.toLocaleString('en-IN')
                        :
                        0
                }
            </div>
        },
    ]

    return (
        <>
            <div className="row pe-0">
                <div className="col-lg-12 pe-0">
                    <div className="card e-dashboard-card border-0">
                        <div className="row pt-2">
                            <div className="col-lg-9 col-3 mb-3">
                                <FundsTab data={["Active", "Cancelled", "Paused"]}
                                    index={index}
                                    setTab={(temp) => {
                                        setIndex(temp);

                                    }} />
                            </div>

                            {/*--------------- order table -----------*/}
                            {
                                loader ?
                                    <Loader />
                                    : (!stpData.length) ?
                                        <EmptyNote note="There are no stps to show" />
                                        :
                                        <div className="col-lg-12 px-0" style={{ position: "relative" }}>
                                            <DataTable
                                                pagination={true}
                                                columns={index === 1 ? ACTIVE_STP_COLUMNS : index === 2 ? CANCELLED_STP_COLUMNS : COMMON_STP_COLUMNS}
                                                data={stpData}
                                                selectableRows={false}
                                                perPage={10}
                                                rowClick={(row) => { }}
                                            />
                                            {/* Total for the current tab, across all rows — backend-provided
                                                via total_amount, not summed client-side. */}
                                            <div className="e-table-total" style={{ position: "absolute", left: "8px", bottom: 0, height: "56px", display: "flex", alignItems: "center", fontWeight: 600 }}>
                                                Total:&nbsp;{totalAmount == null ? '—' : '₹' + totalAmount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                            </div>
                                        </div>
                            }

                        </div>
                    </div>
                </div>
            </div>


            {/* error toast */}
            {
                error !== null ?
                    <Toast
                        data={error}
                        type="eror"
                        id="1"
                    />
                    :
                    null
            }
            {/* Success toast */}
            {
                success !== null ?
                    <Toast data={success}
                        type="success"
                        id="2" />
                    :
                    null
            }
        </>
    );
}

export default StpList;

